import { restartableTask } from 'ember-concurrency';
import Report, { ReportResourceName } from 'volta/models/report';
import StoreService from 'volta/services/store';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { IWidgetArgs } from '../';

interface TReport {
  report?: Report | null;
  reportId?: string | null;
  aspectRatio?: string | null;
}

export default class WidgetTableauReport extends Component<IWidgetArgs> {
  @service store!: StoreService;
  @tracked report?: TReport;

  height = this.args.widget.args?.height ? `${this.args.widget.args?.height}px` : 'auto';

  @action
  updateSize(event: MouseEvent) {
    const { target } = event;
    const height = WidgetTableauReport.targetHeight(target as HTMLElement);
    const { widget } = this.args;
    widget.args = { ...widget.args, height };

    this.args.onChange?.(widget, this.args.column);
  }

  private static targetHeight(target?: HTMLElement | null) {
    if (!target) {
      return undefined;
    }
    const { height } = target.getBoundingClientRect();
    return height;
  }

  loadReport = restartableTask(async () => {
    const { args } = this.args.widget;

    if (!args) {
      return;
    }

    if (typeof args.reportId === 'string') {
      try {
        const report = await this.store.findRecord(ReportResourceName.singular, args.reportId);
        this.report = { report, reportId: args.reportId, aspectRatio: args.aspectRatio } as TReport;
      } catch (e) {
        defaultErrorHandler(e);
      }
    }
  });
}
